import apiList from "@/service/apiList";
import axios from "axios";
import { Message } from "element-ui";
import Vue from "vue";
import { api } from "@/service/api";
import { postJson } from "@/service/api";
import orderApiList from "@/service/basic/orderApiList";

const echarthost = echarthostname;
// 获取商城分类
function getOrderList(params) {
  params.shop_id = localStorage.getItem("shop_id");
  return new Promise(resolve => {
    Vue.prototype.$api
      .get(apiList.orderList, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 订单详情
function getOrderListDetail(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .get(apiList.orderListDetail, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        Message.error("订单有误");
        console.log(err);
      });
  });
}

// 接单备货
function acceptOrder(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.acceptOrder, params)
      .then(function(res) {
        if (res.message === "Success") {
          Message.success("接单备货成功");
        }
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 备货完成
function pareDone(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.pareDone, params)
      .then(function(res) {
        resolve(res);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 取消备货
function cancelPare(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.cancelPare, params)
      .then(function(res) {
        if (res.message === "Success") {
          Message.success("取消备货成功");
        }
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 取消备货
function bigorderCancelPare(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.bigorderCancelPare, params)
      .then(function(res) {
        if (res.message === "Success") {
          Message.success("取消备货成功");
        }
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 备货出库
function outWare(params) {
  return new Promise(resolve => {
    console.log(apiList.outWare);
    Vue.prototype.$api
      .post(apiList.outWare, params)
      .then(function(res) {
        if (res.message === "Success") {
          Message.success("备货出库成功");
        }
        resolve(res);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 紧固件 备货出库
function outWareJgj(params) {
  return new Promise(resolve => {
    console.log(apiList.outWareJgj);
    Vue.prototype.$api
      .post(apiList.outWareJgj, params)
      .then(function(res) {
        if (res.message === "Success") {
          Message.success("备货出库成功");
        }
        resolve(res);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 备货出库
function bigorderOutWare(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.bigorderOutWare, params)
      .then(function(res) {
        // if (res.message === 'Success') {
        //   Message.success('备货出库成功')
        // }
        resolve(res);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 更新打包箱数和称重
function updatePack(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.updatePack, params)
      .then(function(res) {
        resolve(res);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 箱号详情
function listBox(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .get(apiList.listBox, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
function getOrderDetail(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .get(apiList.getOrderDetail, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 拒单
function refuseOrder(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.refuseOrder, params)
      .then(function(res) {
        resolve(res);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 紧固件拒单
function jgjRefuseOrder(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.jgjRefuseOrder, params)
      .then(function(res) {
        resolve(res);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 获取单个订单
function getOrder(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .get(apiList.getOrder, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 获取拒单子订单
function getWrongOrder(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .get(apiList.getWrongOrder, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 获取扫描的订单
function listOrderWithBox(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .get(apiList.listOrderWithBox, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 确定出库
function scanAction(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.scanAction, params)
      .then(function(res) {
        resolve(res);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
function getCurrentStockList(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .get(apiList.listOutWare, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 获得发货清单
function getShippingList(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.orderShippingList, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 获得备货清单
function getStockListing(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.stockListing, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 获得备货清单
function getBigorderStockListing(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.bigorderStockListing, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 获得拒单列表
function getListWrongDetail(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .get(apiList.listWrongDetail, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 获得拒单列表
function getFactoryOrderList(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .get(apiList.getFactoryOrderList, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 获取直发列表
function getshippingListLogistics(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.shippingListLogistics, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 获取直发列表
function printLogisticsSheet(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.printLogisticsSheet, params)
      .then(function(res) {
        resolve(res);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 获取直发列表
function printOneBox(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.printOneBox, params)
      .then(function(res) {
        resolve(res);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 分页打印
async function printPage(params = {}) {
  try {
    axios.defaults.headers["Content-Type"] =
      "application/x-www-form-urlencoded;charset=UTF-81";
    let res = await axios.post(
      "http://127.0.0.1:4050/",
      JSON.stringify(params)
    );
    res = res.data;
    return new Promise((resolve, reject) => {
      if (res.code === 200) {
        Message.success("生成PDF成功");
        resolve(res);
      } else {
        Message.error("未安装PDF生成插件");
        reject(res);
      }
    });
  } catch (err) {
    Message.error("未安装PDF生成插件");
    return new Promise((resolve, reject) => {
      resolve(false);
    });
  }
}
// 导出三方订单
function exporOrdertData(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .get(apiList.exporOrdertData, params)
      .then(function(res) {
        if (res.message === "Success") {
          // Message.success('导出成功，请在邮箱中查收!今日已导出' + res.data + '次')
          Message.success(
            "订单管理报表导出成功，请在报表中心查看下载！今日已导出" +
              res.data +
              "次"
          );
        }
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 自动备货完成
function autoPareDone(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.autoPareDone, params)
      .then(function(res) {
        if (res.code === 200) {
          Message.success("备货完成");
        } else {
          Message.error(res.message);
        }
        resolve(res);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 检查取消订单
function cancelOrderData(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .get(apiList.cancelOrderDialogData, params)
      .then(function(res) {
        if (res.code === 200) {
        } else {
          Message.error(res.message);
        }
        resolve(res);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 采购订单
function getPurchaseList(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .get(apiList.getPurchaseList, params)
      .then(function(res) {
        if (res.code === 200) {
        } else {
          Message.error(res.message);
        }
        resolve(res);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 打印采购订单
function printPurchaseList(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.printPurchaseList, params)
      .then(function(res) {
        if (res.code === 200) {
        } else {
          Message.error(res.message);
        }
        resolve(res);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 打印采购订单
function getOutStockDetail(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.getOutStockDetail, params)
      .then(function(res) {
        if (res.code === 200) {
        } else {
          Message.error(res.message);
        }
        resolve(res);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 获取快递子单号详情
function getTransportDetail(params) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$api
      .get(apiList.getTransportDetail, params)
      .then(function(res) {
        resolve(res);
      })
      .catch(function(err) {
        reject(err);
        console.log(err);
      });
  });
}
// 获取订单各种总数
function loadOrderTotalnum(params) {
  return new Promise((resolve, reject) => {
    api
      .get(`${echarthostname}/system/order/totalnum`, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}
// 更改箱码数量时获取订单列表
function getOrderListForChangeBoxNum(params) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$api
      .get(apiList.getOrderListForChangeBoxNum, params)
      .then(function(res) {
        resolve(res);
      })
      .catch(function(err) {
        reject(err);
        console.log(err);
      });
  });
}
// 保存批量修改的箱码数量
function saveBatchChangeBoxNum(params) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$api
      .post(apiList.saveBatchChangeBoxNum, params)
      .then(function(res) {
        resolve(res);
      })
      .catch(function(err) {
        reject(err);
        console.log(err);
      });
  });
}
// 批量导出货物清单
function batchExportGoodsDetail(params) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$api
      .get(apiList.batchExportGoodsDetail, params)
      .then(function(res) {
        resolve(res);
      })
      .catch(function(err) {
        reject(err);
        console.log(err);
      });
  });
}
function bigorderBatchExportGoodsDetail(params) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$api
      .get(apiList.bigorderBatchExportGoodsDetail, params)
      .then(function(res) {
        resolve(res);
      })
      .catch(function(err) {
        reject(err);
        console.log(err);
      });
  });
}
// 批量打印箱码
function batchPrintBoxCode(params) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$api
      .get(apiList.batchPrintBoxCode, params)
      .then(function(res) {
        resolve(res);
      })
      .catch(function(err) {
        reject(err);
        console.log(err);
      });
  });
}
// 清空打包数量和箱码
function clearBatchChangeBoxNum(params) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$api
      .post(apiList.clearBatchChangeBoxNum, params)
      .then(function(res) {
        resolve(res);
      })
      .catch(function(err) {
        reject(err);
        console.log(err);
      });
  });
}
// 获取物流运单商品列表
function getOrderGoodsDetail(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.orderGoodsDetail, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}

// 获取R4 自配拒单列表
function getR4MatchRefuseList(params) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$api
      .get(apiList.r4MatchRefuseList, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        reject(err);
        console.log(err);
      });
  });
}

// 获取R4 自配拒单详情
function getR4MatchRefuseLisDetail(params) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$api
      .get(apiList.r4MatchRefuseLisDetail, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        reject(err);
        console.log(err);
      });
  });
}
// 物流状态枚举
function getBoxStatus(params) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$api
      .get(echarthost + orderApiList.getBoxStatus, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        reject(err);
        console.log(err);
      });
  });
}
// 订单列表（直发|工厂）
function getNewList(params) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$api
      .get(echarthost + orderApiList.getNewList, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        reject(err);
        console.log(err);
      });
  });
}

// 订单包裹（直发|工厂）
function getBoxList(params) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$api
      .get(echarthost + orderApiList.getBoxList, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        reject(err);
        console.log(err);
      });
  });
}

// 订单包裹-物流轨迹（直发|工厂）
function getPackagetrace(params) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$api
      .get(echarthost + orderApiList.getPackagetrace, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        reject(err);
        console.log(err);
      });
  });
}

// 物流状态枚举
function getShipStatusEnum(params) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$api
      .get(echarthost + orderApiList.getShipStatusEnum, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        reject(err);
        console.log(err);
      });
  });
}
// R4 自配拒单确认
export const r4MatchRefuseOrderSure = (params = {}) =>
  postJson(apiList.r4MatchRefuseOrderSure, params);

export {
  printPurchaseList,
  getOrderList,
  getOrderListDetail,
  acceptOrder,
  pareDone,
  cancelPare,
  bigorderCancelPare,
  outWare,
  outWareJgj,
  bigorderOutWare,
  updatePack,
  listBox,
  getOrderDetail,
  refuseOrder,
  jgjRefuseOrder,
  getOrder,
  getWrongOrder,
  listOrderWithBox,
  scanAction,
  getCurrentStockList,
  getShippingList,
  getStockListing,
  getBigorderStockListing,
  getListWrongDetail,
  getshippingListLogistics,
  printLogisticsSheet,
  printOneBox,
  printPage,
  exporOrdertData,
  autoPareDone,
  cancelOrderData,
  getPurchaseList,
  getOutStockDetail,
  getTransportDetail,
  getOrderListForChangeBoxNum,
  saveBatchChangeBoxNum,
  batchExportGoodsDetail,
  bigorderBatchExportGoodsDetail,
  batchPrintBoxCode,
  clearBatchChangeBoxNum,
  getFactoryOrderList,
  getOrderGoodsDetail,
  loadOrderTotalnum,
  getR4MatchRefuseList,
  getR4MatchRefuseLisDetail,
  getBoxStatus,
  getNewList,
  getBoxList,
  getPackagetrace,
  getShipStatusEnum
};



// WEBPACK FOOTER //
// ./src/models/orderModel.js